<template>
  <div>
    <v-snackbar
      :value="value"
      absolute
      right
      :timeout="timeout"
      color="success"
      top
    >
      data berhasil di upload
    </v-snackbar>

    <v-card class="my-8">
      <v-row class="px-5">
        <v-col cols="12" md="8" sm="12">
          <v-file-input
            class="mt-2"
            v-model="filename"
            accept=".xlsx"
            id="excel_segment"
            placeholder="format upload wajib .xlsx"
            ref="post_title"
            @change="impexcel()"
          ></v-file-input>
        </v-col>
        <v-col cols="6" md="2">
          <v-btn
            class="mt-5 ml-2"
            color="#5E50A1"
            :loading="loading"
            :disabled="disable"
            @click="postData"
            style="color:#fff"
          >
            UPLOAD FILE
          </v-btn>
        </v-col>
         <v-col cols="6" md="2" class="mt-5">
          <SampleExcel :sheets="sheet" :fname="fname"/>
        </v-col>
      </v-row>
    </v-card>
    <v-skeleton-loader v-if="firstLoad" :loading="loading" type="table"></v-skeleton-loader>
    <v-data-table
      dense
      :headers="headers"
      :items="data"
      :fixed-header="true"
      item-key="no"
      :page.sync="page"
      v-show="!firstLoad"
      :items-per-page="itemsPerPage"
      hide-default-footer=""
      @page-count="pageCount = $event"
      class="mt-5 elevation-5"
      style="padding: 15px"
      :options.sync="options"
    >
      <template v-slot:item="row">
        <tr>
          <!-- <td>{{row.item.ID}}</td> -->
          <td>{{ row.item.NumberAccount }}</td>
          <td>{{ row.item.Channel }}</td>
          <td>{{ row.item.Segment }}</td>
          <td>{{ row.item.UploadedBy }}</td>
          <td>
            <div style="padding: 5px">
              <v-btn v-model="mirrorId" color="red" small
                ><v-icon small @click="delUpload(row.item.ID)" color="white">
                  mdi-delete
                </v-icon></v-btn
              >
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div style="display: flex; justify-content: end; margin-top: 20px">
      <p class="mt-2" v-show="!firstLoad">page {{ page }} to {{ pageCount }}</p>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        v-show="!firstLoad"
        color="#5E50A1"
        :options.sync="options"
      >
      </v-pagination>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import readXlsFile from "read-excel-file";
import "../store/store.js";
import SampleExcel from "@/components/SampleExcel.vue";


export default {
  props:['sheet','fname'],
  components:{
    SampleExcel
  },
  data: () => ({
    timeout: 3000,
    firstLoad: true,
    filename: null,
    mirrorId: [],
    page: 1,
    options: {},
    value: false,
    idSegment: [],
    disable: false,
    pageCount: 0,
    itemsPerPage: 20,
    items: null,
    
    firstLoad: true,
    loading: false,
    headers: [
      { id: 2, text: "Number Account", value: "NumberAccount" },
      { id: 3, text: "Channel", value: "Channel" },
      { id: 3, text: "Segment", value: "Segment" },
      { id: 4, text: "Uploaded By", value: "UploadedBy" },
      { id: 5, text: "Action", value: "butn" },
    ],
    data: [],
  }),
  watch: {
    options: {
      handler() {
        console.log("options watcher called");
        this.getItem();
      },
      deep: true,
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
  methods: {
    getItem() {
      this.$store
        .dispatch("getUploadDataSegment")
        .then((response) => {
          if (response.data.code == 200) {
            const item = response.data.data;
            this.firstLoad=false
            item.records.forEach((x) => {
              this.data.push(x);
            });
          }
        })
        .catch(function (error) {});
    },
    impexcel() {
      const input = document.getElementById("excel_segment");
      readXlsFile(input.files[0]).then((rows) => {
        this.items = rows;
        let keys = this.items[0];

        let newArr = this.items.slice(1, this.items.length);

        let formatted = [],
          data = newArr,
          cols = keys,
          l = cols.length;
        for (let i = 0; i < data.length; i++) {
          let d = data[i],
            o = {};
          for (let j = 0; j < l; j++) o[cols[j]] = d[j];
          formatted.push(o);
        }
        this.items = formatted;
      });
    },
    postData() {
      const data = { items: this.items };
      this.loading = true;
      // console.log(items)
      if (this.filename) {
        const data = { items: this.items };
        this.loading = true;
        this.disable = false;
        this.$store
          .dispatch("postUploadDataSegment", data)
          .then((response) => {
            if (response.status == 201 || response.status == 200) {
              this.value = true;
              this.filename = null;

              setTimeout(() => (this.loading = false), 2000);
              this.$router.go(this.$router.currentRoute);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.loading = true
        alert("upload data tidak boleh kosong") 
        this.$router.go(this.$router.currentRoute);
      }
    },
    delUpload(id) {
      this.$swal({
        title: "Hapus Data? ",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5E50A1",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("delUploadDataSegment", id).then((response) => {
            console.log(response);
            this.$swal("Berhasil dihapus").then((result) => {
              console.log(result);
              if (result.value) {
                this.$router.go(this.$router.currentRoute);
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getItem();
  },
};
</script>
<style scoped>
.v-input__slot {
  min-height: 45px !important;
}
</style>